const $inject = ['moment'];

const ndcExpiredService = function (moment) {
  const service = {};

  service.activeExpirationTime = null;

  service.checkForExpired = function checkForExpired(fare) {
    if (!fare || !fare.FlightExpirationTimeLimit) return;
    
    let diff = moment(fare.FlightExpirationTimeLimit).diff(new Date(), 'minutes');
    console.log(`expires in ${diff} mins`);

    if (diff <= 0) {
      service.hasExpired = true;
    }
  }

  service.hasExpired = false;

  return service;
};

ndcExpiredService.$inject = $inject;

export default ndcExpiredService;



// WEBPACK FOOTER //
// ./src/services/ndcExpiredService.js